import React from 'react'
import s from "./TimeBox.module.css";

export type TimeBoxProps = {
  measure: number;
  beat: number;
  tick: number;
};

export const TimeBox: React.FC<TimeBoxProps> = ({ measure, beat, tick }) => {
  return (
    <div className={s.timeBox} role="group" aria-label="Позиция в тактах">
      <div className={s.timeBoxColumn}>
        <div className={s.timeBoxLabel}>Measure</div>
        <div className={s.timeBoxValue}>{measure}</div>
      </div>
      <div className={s.timeBoxColumn}>
        <div className={s.timeBoxLabel}>Beat</div>
        <div className={s.timeBoxValue}>{beat}</div>
      </div>
      <div className={s.timeBoxColumn}>
        <div className={s.timeBoxLabel}>Tick</div>
        <div className={s.timeBoxValue}>{tick}</div>
      </div>
    </div>
  );
};